// extracted by mini-css-extract-plugin
export default {"addresses_info_section":"AddressesInfoSection_addresses_info_section__mNasL","with_pointer_cursor":"AddressesInfoSection_with_pointer_cursor__0GIz1"};